<template>
    <content-layout>
        <h1 slot="header" class="category-title">Materiālu sadalījums</h1>

        <div class="row my-category">
            <div class="small-6 medium-4 large-2 column sidebar">
                <my-profile-info v-if="user" class="profile-info"></my-profile-info>
            </div>
            <div v-if="category" class="small-6 medium-8 large-10 column content">
                <h4 class="breadcrumb">
                    <span class="crumb"><router-link :to="{ name: 'profile' }">Mans profils</router-link></span>
                    <span class="crumb" v-for="p in category.path">
                        <router-link :to="{ name: 'profile.categories', params: { categoryNodeId: p.id } }" :key="p.id">{{p.category.title}}</router-link>
                    </span>
                    <span class="crumb">{{ title }}</span>
                </h4>
                <div class="row small-up-1 medium-up-2 large-up-4">
                    <spinner v-if="loadingCategories === true" class="spinner"></spinner>
                    <div v-else class="column" v-for="categoryNode in subCategoryNodes">
                        <category-item
                                :linkTo="{ name: 'profile.categories', params: { categoryNodeId: categoryNode.id } }"
                                :title="categoryNode.category.title"
                                :icon="categoryNode.category.icon_url"
                                :count="categoryNode.category.user_materials_count"></category-item>
                    </div>
                </div>

                <hr/>

                <div class="file-list-container row small-up-2 medium-up-3 large-up-4">
                    <spinner v-if="loading === true" class="spinner"></spinner>
                    <div v-else class="column" v-for="material in materials">
                        <my-material-item :material="material"></my-material-item>
                    </div>
                </div>

                <div v-if="materials.length > 0" class="pagination-container">
                    <pagination :current.sync="page" :total="pages"></pagination>
                </div>
            </div>
        </div>
    </content-layout>
</template>

<script>
    import ContentLayout from '../../layouts/ContentLayout'
    import CategoryItem from '../../components/CategoryItem'
    import categories from '../../api/categories'
    import MyProfileInfo from '../../components/profile/MyProfileInfo'
    import MyMaterialItem from '../../components/MyMaterialItem'
    import Pagination from '../../components/common/Pagination'
    import { mapGetters } from 'vuex'
    import materials from "../../api/materials";

    export default {

        created() {
            if (this.user) {
                this.getCategory()//FIXME on route change
            }
        },

        props: {
            'categoryNodeId': {
                type: [Number, String],
                required: true
            }
        },

        data() {
            return {
                category: null,
                title: '',
                subCategoryNodes: [],
                page: 1,
                materials: [],
                pages: 1,
                path: [],

                loadingCategories: false,
                loading: false
            }
        },

        computed: {

            ...mapGetters(['user']),
        },

        methods: {
            /**
             * Get User materials or bookmarks.
             */
            getMaterials() {
                const cats = this.category.path.map(function (cat) {return cat.category_id;});
                cats.push(this.category.category_id);

                console.log('getting materials for category', cats);

                this.loading = true;
                return materials.get({ page: this.page, owner: this.user.id, categories: cats })
                    .then(response => {
                        console.log('get materials', response.data);
                        this.setMaterial(response.data);
                        this.loading = false;
                        return response;
                    })
            },

            /**
             * Set materials from API response data
             *
             * @param {Array} data
             * @param {Object} meta
             */
            setMaterial({ data, meta }) {
                this.materials = data;
                this.pages = meta ? meta.last_page : 1;
                this.page = meta ? meta.current_page : 1;
            },

            getCategory() {
                // TODO lookup in store
                // TODO optimise: only children count is needed.
                return categories.find(this.categoryNodeId)
                    .then(response => {
                        console.log('setting new category');
                        this.category = response.data;
                        this.title = this.category.category.title;
                        this.path = this.getOrderedCategoryNodes(this.category.path);
                        return response;
                    })
            },

            /**
             * Sorts the given nodes in hierarchical order
             * @param nodes
             */
            getOrderedCategoryNodes(nodes) {

                function getParent(node, all) {
                    return all.find(n => node.parent_id === n.id)
                }

                function isDescendant(child, parent, all) {
                    //Return true immediately if child is direct descendant of parent
                    if (child.parent_id === parent.id) return true

                    //Look for parent recursively
                    let p = child
                    while (p = getParent(p, all)) {
                        if (p.id === parent.id) return true
                    }

                    //Finally assume that the child is not descendant of the given parent
                    return false
                }

                //It is assumed that parent has only one node
                nodes.sort(function (a, b) {
                    if (a.parent_id === null) return -1
                    if (isDescendant(a, b, nodes)) return 1
                    else return 0
                });
            },

            /**
             * Get sub categories
             */
            getSubCategories() {
                console.log('getting sub cats');
                this.loadingCategories = true;
                return categories.get({ parent_id: this.category.id, depth: 1, with_user_item_count: this.user.id })
                    .then(response => {
                        this.subCategoryNodes = response.data;
                        this.loadingCategories = false;
                        return response;
                    })
            },

            reset() {
                Object.assign(this.$data, this.$options.data.apply(this))//Resetting component data
            }
        },

        watch: {
            'categoryNodeId': function (val, oldVal) {
                this.subCategoryNodes = [];
                this.materials = [];
                console.log('categoryNodeId changed', val, oldVal)

                this.getCategory()
            },

            'user': function (val) {
                //FIXME both user and category is required to load materials...
                if (val) {
                    console.log('user changed, loading cats')
                    this.getCategory()
                }
            },

            'category': function (val, oldVal) {
                console.log('category changed', val, this.category.children.length)
                this.getSubCategories()
                    .then(response => this.getMaterials());
            },

            /**
             *
             * @param val
             * @param oldVal
             */
            page: function (val, oldVal) {
                console.log('page changed', val, oldVal);
                if (typeof val !== 'undefined' && val !== null  && val !== oldVal) {
                    this.getMaterials();
                }
            }
        },

        components: { CategoryItem, ContentLayout, MyProfileInfo, Pagination, MyMaterialItem }
    }
</script>

<style lang="scss" scoped="">

    .sidebar,
    .content {
        padding-top:  30px;
    }

    //TODO duplicate
    .file-list-container {
        padding-bottom: 1.875rem;
    }

    //TODO duplicate
    .pagination-container {
        text-align: center;
    }


    //TODO create breadcrumb
    .breadcrumb {
        margin-bottom: 2rem;
    }
</style>


// WEBPACK FOOTER //
// resources/assets/js/views/profile/MySubCategories.vue